/**
 * LostPasswordCtrl controller
 */

/**
 * LostPasswordCtrl controller
 *
 * @class LostPasswordCtrl
 * @memberof mwApp/auth
 * @see mwApp/auth
 *
 * @ngdoc controller
 * @name mwApp/auth.controller:LostPasswordCtrl
 */
/* @ngInject */
export default function LostPasswordCtrl ($state, $stateParams, authSvc, alertSvc) {
  var vm = this

  vm.tokenError = $stateParams.tokenError

  // init timezone request
  authSvc.timezone()

  /**
   * User object
   *
   * @memberof mwApp/auth.controller:LostPasswordCtrl
   * @type {Object}
   */
  vm.user = {
    name: null
  }

  vm.loadImage = function(img) {
    return require('../../img/' + window.ENV.APP_PROVIDER + '/' + window.ENV.APP_PROVIDER + img)
  }

  /**
   * Perform request to restore user's password
   *
   * @memberof mwApp/auth.controller:LostPasswordCtrl
   */
  vm.lostPassword = function () {
    authSvc.restorePassword(vm.user)
      .then(
        response => {
          alertSvc.alert(response.data, 'success')
          $state.go('login')
        }
      ).catch((error) => {
        alertSvc.alert(error.data, 'warning')
      })
  }
}
